import { render } from "./HomeVideo.vue?vue&type=template&id=551d48bb&scoped=true"
import script from "./HomeVideo.vue?vue&type=script&lang=js"
export * from "./HomeVideo.vue?vue&type=script&lang=js"

import "./HomeVideo.vue?vue&type=style&index=0&id=551d48bb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551d48bb"]])

export default __exports__